import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { initialAndSearchStateSetter } from '../../Utility/InitialAndSearchStateSetter/InitialAndSearchStateSetter';
import { generateRandomString } from '../../Utility/GenerateRandomString/GenerateRandomString';
import { useNavigate } from 'react-router-dom';
import { mapStateToPropsForAllData } from '../../Utility/MapStateToPropsForAllData/MapStateToPropsForAllData';

function Opportunities({ allDataOfContact, searchedDataOfContact }) {

  // sessionStorage.setItem("Pdsk21D34Rl98", false);

  const [isLoading, setIsLoading] = useState(true);
  const [opportunitiesData, setOpportunitiesData] = useState({});
  const navigate = useNavigate();
  const { searchedKeyword } = useParams();

  useEffect(() => {

    initialAndSearchStateSetter(searchedKeyword, searchedDataOfContact, navigate, setIsLoading, setOpportunitiesData, allDataOfContact);

  }, [allDataOfContact, searchedDataOfContact, isLoading, searchedKeyword]);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
         <Grid container spacing={3}>
         <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'left', marginLeft: 2, fontWeight: 'bold' }}
            >
              Opportunities
            </Typography>
            { isLoading ? <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}>
      <CircularProgress />
    </Box>  : ((opportunitiesData?.data && opportunitiesData?.data?.Opportunities && opportunitiesData?.data?.Opportunities?.totalSize) != 0 ? <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Stage Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Lead Source</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Close Date</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {opportunitiesData?.data && opportunitiesData?.data?.Opportunities?.records?.map((opportunityData) => {

          const opportunityIdOfContact = generateRandomString()+"00JZ3"+opportunityData.Id+generateRandomString();

          return (
            <TableRow key={opportunityData.Id}>
            <TableCell><Link to={`/OpportunityDetail/${opportunityIdOfContact}`} style={{ textDecoration: 'none', color: '#1976D2' }}>{opportunityData.Name}</Link></TableCell>
            <TableCell>{opportunityData.StageName}</TableCell>
            <TableCell>{opportunityData.LeadSource}</TableCell>
            <TableCell>{opportunityData.CloseDate}</TableCell>
            <TableCell>{`$${opportunityData.Amount == null ? 0 : opportunityData.Amount}`}</TableCell>
          </TableRow>
          )
        } )}
        </TableBody>
      </Table>  : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}><p>No Records Found!</p></div>) }
        
      </Grid> 
      </Container>
 
  )
}

export default connect(mapStateToPropsForAllData)(Opportunities);